<template>
    <div class="commercials">
        <v-card height="200px">
            <v-parallax height="200" src="/content/parallax.jpg">
                <v-card-text>
                    <v-layout row justify-space-between align-center>
                        <v-flex xs12 md9 lg10>
                            <v-layout row justify-start align-center class="hidden-md-and-down">
                                <v-flex xs12 sm6 md4 lg3
                                        v-for="(item,i) in periodic_adv.files.slice(0,3)"
                                        :key="i">
                                    <template v-if="item.type==='image'">
                                        <v-img style="cursor: pointer; max-width: 284px;" height="160"
                                               :src="item.path+item.name"
                                               @click="navigate_to(item.link)"
                                               contain
                                        ></v-img>
                                    </template>
                                    <template v-if="item.type==='video'">
                                        <div @click="navigate_to(item.link)"
                                             style="cursor: pointer; max-width: 284px;">
                                            <video-player :options="item.playerOptions"></video-player>
                                        </div>
                                    </template>
                                </v-flex>
                            </v-layout>
                            <v-layout row justify-start align-center class="hidden-xs-only hidden-lg-and-up">
                                <v-flex sm6 md4
                                        v-for="(item,i) in periodic_adv.files.slice(0,2)"
                                        :key="i">
                                    <template v-if="item.type==='image'">
                                        <v-img style="cursor: pointer; max-width: 284px;" height="160"
                                               :src="item.path+item.name"
                                               @click="navigate_to(item.link)"
                                               contain
                                        ></v-img>
                                    </template>
                                    <template v-if="item.type==='video'">
                                        <div @click="navigate_to(item.link)"
                                             style="cursor: pointer; max-width: 284px;">
                                            <video-player :options="item.playerOptions"
                                                          style="max-height: 160px; cursor: pointer;"
                                            >
                                            </video-player>
                                        </div>
                                    </template>
                                </v-flex>
                            </v-layout>
                            <v-layout row align-center class="hidden-sm-and-up">
                                <v-flex xs12
                                        v-for="(item,i) in periodic_adv.files.slice(0,1)"
                                        :key="i">
                                    <template v-if="item.type==='image'">
                                        <v-img style="cursor: pointer; max-width: 284px;" height="160"
                                               :src="item.path+item.name"
                                               @click="navigate_to(item.link)"
                                               contain
                                        ></v-img>
                                    </template>
                                    <template v-if="item.type==='video'">
                                        <div @click="navigate_to(item.link)"
                                             style="cursor: pointer; max-width: 284px;">
                                            <video-player :options="item.playerOptions"
                                                          style="max-height: 160px; cursor: pointer;"
                                            >
                                            </video-player>
                                        </div>
                                    </template>
                                </v-flex>
                            </v-layout>
                        </v-flex>

                        <v-flex md4 lg3 class="hidden-sm-and-down">
                            <v-carousel hide-delimiters hide-controls
                                        touchless style="width: 284px; float: right;"
                                        height="160">
                                <v-carousel-item
                                        v-for="(item,i) in static_adv.files"
                                        :key="i"
                                        :src="item.path+item.name"
                                        @click="navigate_to(item.link)"
                                        style="cursor: pointer"
                                ></v-carousel-item>
                            </v-carousel>
                        </v-flex>
                   </v-layout>
                </v-card-text>
            </v-parallax>
        </v-card>
    </div>
</template>

<script>
    import $ from 'jquery'
    export default {
        name: "Commercials",
        data(){
            return {
                periodic_adv: {
                    files: [],
                },
                static_adv: {
                    files: [],
                },
            }
        },
        created() {

        },
        mounted() {
            this.load_json();
        },
        methods: {
            // Request to list files in folders
            load_json() {
                $.ajax({
                    url: '/content/media/periodic.json',
                    type: 'GET',
                    data: {},
                    success: (response) => {
                        if (typeof response === 'object')
                            this.periodic_adv.files = this.shuffle(response);
                    },
                    error: () => {
                        this.periodic_adv.files = [];
                    },
                });
                $.ajax({
                    url: '/content/media/static.json',
                    type: 'GET',
                    data: {},
                    success: (response) => {
                        if (typeof response === 'object')
                            this.static_adv.files = this.shuffle(response);
                    },
                    error: () => {
                        this.static_adv.files = [];
                    },
                });
            },
            shuffle(array) {
                var currentIndex = array.length, temporaryValue, randomIndex;
                // While there remain elements to shuffle...
                while (0 !== currentIndex) {
                    // Pick a remaining element...
                    randomIndex = Math.floor(Math.random() * currentIndex);
                    currentIndex -= 1;
                    // And swap it with the current element.
                    temporaryValue = array[currentIndex];
                    array[currentIndex] = array[randomIndex];
                    array[randomIndex] = temporaryValue;
                }
                return array;
            },
            navigate_to(url) {
                if (url.startsWith('http')) {
                    window.open(url, '_blank');
                } else {
                    this.$router.push(url);
                }
            }
       },
        filters: {

        },
        props: {

        },
    }
</script>

<style scoped>

</style>